<template>
    <div id="home">
        <div id="title">人工智能、机器学习的理论与实践</div>
        <div id="name">李海</div>
        <div id="email">li.hai@vip.163.com</div>
		<div id="divider"/>
    	<div id="body">
        	<ul class="content">
				<li v-for="(item, index) in pdfs" :key="index" @click="viewPdf(item.filename)" class="link">
					{{ item.label }}
				</li>
			</ul>
    	</div>
    	<div id="footer">
			<a href="http://beian.miit.gov.cn" style="text-decoration:none;font-size:12px;">京ICP备18063603号</a><!-- 超级链接不显示下划线 -->
		</div>
    </div>
</template>

<script>
export default {
  data () {
	return {
		pdfPath: '',
		pdfs: [
			{ label: '人工神经网络（ANN）', filename: 'ml-ANN.pdf' },
			{ label: '卷积神经网络（CNN）', filename: 'ml-CNN.pdf' },
			{ label: '循环神经网（RNN）', filename: 'ml-RNN.pdf' },
			{ label: '强化学习（RL）', filename: 'ml-RL.pdf' },
			{ label: '变分自编码器（VAE）', filename: 'ml-VAE.pdf' },
			{ label: '生成对抗网络（GAN）', filename: 'ml-GAN.pdf' },
			{ label: '知识图谱（Knowledge Graph）', filename: 'ml-KG.pdf' },
			{ label: '支持向量机（SVM）', filename: 'ml-SVM.pdf' },
			{ label: '条件随机场（CRF）', filename: 'ml-CRF.pdf' },
			{ label: '隐马尔可夫模型（HMM）', filename: 'ml-HMM.pdf' },
			{ label: '线性回归（Linear Regression）', filename: 'ml-linear.pdf' },
			{ label: '自适应线性单元（ALU）', filename: 'ml-ALU.pdf' },
			{ label: '逻辑回归（Logistic Regression）', filename: 'ml-LR.pdf' },
			{ label: 'Softmax回归（Softmax Regression）', filename: 'ml-softmax.pdf' },
			{ label: 'NaiveBayes', filename: 'ml-NaiveBayes.pdf' },
			{ label: '决策树（Decision Tree）', filename: 'ml-DTree.pdf' },
			{ label: 'Apriori', filename: 'ml-Apriori.pdf' },
			{ label: 'FP-growth', filename: 'ml-FPgrowth.pdf' },
			{ label: '主成分分析（PCA）', filename: 'ml-PCA.pdf' },
			{ label: '遗传算法（GA）', filename: 'ml-GA.pdf' },
			{ label: '奇异值分解（SVD）', filename: 'ml-SVD.pdf' },
			{ label: '信息熵（Entropy）', filename: 'ml-entropy.pdf' },
			{ label: '人工智能先决条件', filename: '人工智能先决条件.pdf' },
			{ label: '有限状态机（FSM）', filename: 'ml-FSM.pdf' },
			{ label: '马尔可夫链（Markov Chain）', filename: 'ml-MarkovChain.pdf' },
			{ label: '蒙特卡洛树搜索（MCTS）', filename: 'ml-MCTS.pdf' },
			{ label: 'TF-IDF', filename: 'ml-TF-IDF.pdf' }
		]
	}
  },

  mounted() {
    document.body.style.overflow = 'hidden' // 隐藏页面滚动条
  },

  methods: {
    viewPdf (pdf) {
      window.open(pdf)
	}
  }
}
</script>

<style scoped>
#home {
  display: flex;
  flex-direction: column;
  text-align: center;
  height: 100vh;
}
#title {
  padding-top: 15px;
  height: 45px;
  font-size: 35px;
  font-weight: bold;
  color: rgb(68, 43, 10);
}
#name {
  height: 20px;
  font-size: 16px;
  color:darkgray
}
#email {
  height: 20px;
  font-size: 16px;
  color:darkgray
}
#divider {
  width: 100%;
  height: 1px;
  margin-top: 5px;
  border: none;
  background-color: rgb(205, 203, 203);
}
#body {
  overflow-y: scroll;
  flex: 1;
  margin-top: 5px;
}
.content {
  padding-left: 40%;
  text-align: left;
  font-size: 17px;
  color: rgb(68, 43, 10);
}
.link{
  cursor: pointer;
}
#footer {
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: 23px;
  background-color: #eee;
}
</style>
